<template>
  <div class="container" @mouseout="washow = false">
    <div class="uia">
      <div class="minu" id="jump0">
        <div class="head">
          <div class="headLogo" @click="$router.push('/')">
            <img class="headLogo_img" src="../../static/img/logoname.png" alt="" />
          </div>
          <div class="headMinu">
            <div class="headAbout">
              <div :class="headindex == 1 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(1)">О нас</div>
              <div :class="headindex == 2 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(2)">Как его получить? </div>
              <div class="headAbout_textTwo" @click="documentFn">Лицензия на МФО</div>
            </div>
            <!-- <div class="headLang">
              <div class="headLang_e">QZ</div>
              <div class="headLang_h">RU</div>
            </div> -->
            <!-- <div class="head_btn" @click="getlogin">Bойти</div> -->
          </div>
          <div @mouseover="washow = true">
            <div>
              <div class="ioad">
                <img class="uyas" src="../../static/img/phone.png" alt="" />
                <div :class="washow ? 'ioks' : 'ijse'">+7 775 030 86 86</div>
                <img class="uyas" :src="washow ? '../../static/img/up.png' : '../../static/img/jt.png'" alt="" />
              </div>
              <div class="iunm">Пн-Пт: 10:00-19:00.Сб-Вс: выходные</div>
            </div>
            <div class="nbfd">
              <div class="iola" v-if="washow">
                <img class="iuas" src="../../static/img/wt.png" alt="" />
                <div class="ijto">+{{WhatsAppphone}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间 -->
      <div class="minu_con">
        <div class="content">
          <div class="oiua">Микрокредит онлайн  с минимальной процентной ставкой от <span class="iuqa">0.01% в день</span> </div>
          <!-- <div class="content_mi">
            <div class="content_mi-tit">Доступная сумма кредита</div>
            <div class="content_miNum">
              <img class="content_miNum-img" src="../../static/img/js.png" alt="" @click="getreduce" />
              <div style="text-align: center;margin-bottom: 0.27rem;">
                <span class="content_mi-num">{{unitConverter(loannum)}}</span>
                <span class="content_mi-f">〒</span>
              </div>
              <img class="content_miNum-img" src="../../static/img/zj.png" alt="" @click="getadd" />
            </div>
            <div class="content_mi-line"></div>
            <div class="content_mi-btn" @click="getlogin">Получить {{unitConverter(loannum)}} 〒</div>
            <div class="content_mi-text">*В зависимости от срока и сyммы микрокредита</div>
            <div class="content_mi-bom">
              <div class="content_mi-bom-text">Сумма к погашению</div>
              <div class="content_mi-bom-text">{{unitConverter(Interest)}} 〒</div>
            </div>
          </div> -->
          <!-- <div class="content_mi-down">
            <img class="content_mi-down-img" src="../../static/img/googleplay.png" alt="" @click="googleFn" />
            <img class="content_mi-down-img" src="../../static/img/AppStore.png" alt="" @click="appstoreFn" />
          </div> -->
        </div>
        <!-- Быстро взять — легко погасить -->
        <div>
          <div class="contTwo_title wow animate__fadeInDown">Быстро взять — легко погасить</div>
          <div class="contThree">
            <div :class="switchIndex == 1 ? 'contThree_btn-y' : 'contThree_btn-n'" @click="getswitch(1)">Как оформить
              микрокредит</div>
            <div :class="switchIndex == 2 ? 'contThree_btn-y' : 'contThree_btn-n'" @click="getswitch(2)">Как погасить
              микрокредит</div>
          </div>
          <!-- Как оформить микрокредит -->
          <div class="contThree_minu" v-if="switchIndex == 1">
            <div class="contThree_minu-div wow animate__fadeInDown">
              <img class="contThree_minu-div-img" src="../../static/img/o.png" alt="" />
              <div class="contThree_minu-div-title">Заполните анкету на сайте</div>
              <div class="contThree_minu-div-text">Вам понадобится документ, удостоверяющий личность, мобильный телефон и
                адрес электронный почты.</div>
            </div>
            <div class="contThree_minu-div wow animate__fadeInDown">
              <img class="contThree_minu-div-img" src="../../static/img/t.png" alt="" />
              <div class="contThree_minu-div-title">Решение об одобрении онлайн</div>
              <div class="contThree_minu-div-text">Мы проверим вашу заявку и отправим вам решение моментально.</div>
            </div>
            <div class="contThree_minu-div wow animate__fadeInDown">
              <img class="contThree_minu-div-img" src="../../static/img/s.png" alt="" />
              <div class="contThree_minu-div-title">Получение онлайн</div>
              <div class="contThree_minu-div-text">Деньги, одобренные по вашей заявке, поступят на вашу карту или счёт.
              </div>
            </div>
          </div>
          <!-- Как закрыть микрокредит -->
          <div class="contThree_minuTwo wow animate__fadeInDown" v-if="switchIndex == 2">
            <div class="contThree_minu-div">
              <img class="contThree_minu-div-img" src="../../static/img/o.png" alt="" />
              <div class="contThree_minu-div-title">В личном кабинете</div>
              <div class="contThree_minu-div-textTwo">Закройте микрокредит мгновенно в личном кабинете любой банковской
                картой</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 中间第二部分 -->
    <div class="minu_con">
      <!-- Наше преимущество -->
      <div class="contTwo">
        <div class="contTwo_title wow animate__fadeInDown">Наше преимущество</div>
        <div class="contTwo_min">
          <!-- Нет ипотеки, Полностью онлайн -->
          <div class="contTwo_div wow animate__backInLeft">
            <img class="contTwo_div-img" src="../../static/img/sj.png" alt="">
            <div class="contTwo_div-title">Нет ипотеки, Полностью онлайн</div>
            <div class="contTwo_div-text">Без залога и поручителей，В любое время и в любом месте действуйте на своем
              мобильном телефоне, и деньги будут переведены на вашу банковскую карту.</div>
          </div>
          <div class="contTwo_div wow animate__backInDown">
            <img class="contTwo_div-img" src="../../static/img/1.png" alt="">
            <div class="contTwo_div-title">Удобный, Прозрачное кредитование</div>
            <div class="contTwo_div-text">Нет необходимости стоять в очереди, автоматическая проверка, кредит можно
              оформить за несколько минут. Низкие процентные ставки и полная прозрачность.</div>
          </div>
          <div class="contTwo_div wow animate__backInRight">
            <img class="contTwo_div-img" src="../../static/img/g.png" alt="">
            <div class="contTwo_div-title">Отличный сервис, Безопасность</div>
            <div class="contTwo_div-text">Создавайте персонализированные решения для пользователей, Вся информация
              пользователей защищена и регулируется законом.</div>
          </div>
        </div>
      </div>
      <!-- Скачайте приложение Moneyman -->
      <div class="cont_google">
        <div class="cont_google-title wow animate__fadeInDown">Скачайте приложение Быстрый займ</div>
        <!-- <img class="cont_google-img" src="../../static/img/googleplay.png" alt="" @click="googleFn" /> -->
      </div>
      <!-- 详情  可滚动 -->
      <div class="minu_scroll" style="height: 0.8rem;overflow-y:auto;margin-bottom: 0.63rem;">
        <div class="minu_scroll-title wow animate__fadeInLeft">Услуги, которые мы предоставляем:</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">● Доступная сумма микрокредита: от 10 000 до 185 000 тенге</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">● Максимальный срок погашения микрокредита: 365 дней</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">● Минимальная годовая процентная ставка: 1%</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">● Максимальная годовая процентная ставка: 36%</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">● Минимальный возраст для получения кредита: 18 лет</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">Пример расчета:</div>
        <div class="minu_scroll-text wow animate__fadeInLeft" style="margin-bottom: 0.1rem;">Возьмите взаймы 50 000 тенге на 100 дней,
          процентная ставка составляет 0,09% в
          день, затем выплачиваемые проценты составляют 4500 тенге, (50,000*0.09%*100=4,500). По истечении срока
          необходимо вернуть всего 54 500 тенге.</div>
        <div class="minu_scroll-title wow animate__fadeInLeft">Кого мы можем обслуживать:</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">● Жители Республики Казахстан, достигшие возраста 18 лет и старше</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">● Имеющие действительное удостоверение личности</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">● Имеющие номер мобильного телефона в Казахстане</div>
        <div class="minu_scroll-text wow animate__fadeInLeft">● Имеющие действительную банковскую карту, выпущенную любым банком в Казахстане
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bom">
      <div class="bom_title">Mfo Eckz, Too</div>
      <img class="bom_bg" src="../../static/img/d.png" alt="" />
      <div style="display: flex;justify-content: space-between;">
        <div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/tel.png" alt="" />
            <div class="bom_min-textpj">+7 775 030 86 86</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/wa.png" alt="" />
            <div class="bom_min-textpj">+{{WhatsAppphone}}</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/time.png" alt="" />
            <div class="bom_text">Пн-Пт 10:00-19:00 Сб, Вс выходные</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/email.png" alt="" />
            <div class="bom_min-text-two">info@mfoeckz.com</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/add.png" alt="" />
            <div class="bom_min-two">Казахстан, город Алматы, Бостандыкский район,улица Еділ Ерғожин, здание 27, 46
            </div>
          </div>
        </div>

        <div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;margin-top: 0.08rem;" @click="homeFn(0)">Главная
            страница</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(1)">О нас</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(2)">Как его получить?</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(3)">документ</div>
        </div>

        <div>
          <div class="bom_text-two">Скачивай мобильное приложение через:</div>
          <div class="bomIMg" style="margin-bottom: 0.25rem">
            <img class="bom_img" style="margin-right: 0.1rem;" src="../../static/img/googleplay.png" alt="" @click="googleFn" />
            <img class="bom_img" src="../../static/img/AppStore.png" alt=""  @click="appstoreFn" />
          </div>
          <div class="payment_minu">
            <img class="payment_minu-img" style="margin-right: 0.1rem;" src="/static/img/mastercar.png" alt="" />
            <img class="payment_minu-img" src="/static/img/visa.png" alt="" />
          </div>
        </div>
      </div>

      <!-- 支付相关 -->
      <div class="payment">
        <div class="payment-line"></div>
        <div class="payment_text">ТОО «МФО ECKZ», Лицензия на осуществление микрофинансовой деятельности № 02.24.0011.М,
          от 12.09.2024 года, выдана Управлением региональных представителей в городе Алматы Агентства Республики
          Казахстан по регулированию и развитию финансового рынка.</div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    userStepData,
    cfgIndex
  } from '@/api/info'
  import { WOW } from 'wowjs'
  export default {
    name: "home",
    data() {
      return {
        headindex: -1,
        switchIndex: 1,
        loannum: 165000, //借款金额
        Interest: 0, //利息
        flage: false,
        washow: false,//是否显示wa
        WhatsAppphone: ''
      };
    },
    created() {
      if (this.loannum != 0) {
        this.Interest = this.loannum * 1.0001
      }
      this.cfgIndexfn()
    },
    mounted() {
      document.querySelector("#jump" + 0).scrollIntoView(true);
      this.$nextTick(() => {
          // 保存实例到组件实例中，方便后续调用
          this.wowInstance = new WOW({
            boxClass: 'wow',
            animateClass: 'animate__animated', // 注意：Animate.css v4+ 类名前缀是 animate__
            offset: 0,
            mobile: true,
            live: true
          });
          this.wowInstance.init(); // 初始化
          this.wowInstance.sync();
        });
    },
    methods: {
      // 获取全局配置
      cfgIndexfn(){
        cfgIndex().then(res => {
          let WhatsAppphone = res.data.data.WhatsAppphone
          this.WhatsAppphone = WhatsAppphone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 $2 $3 $4');
        })
      },
      // 金额增加
      getadd() {
        if (this.loannum == 185000) return
        this.loannum += 5000; // 每次点击增加5000
        this.Interest = this.loannum * 1.0001
      },
      // 金额减少
      getreduce() {
        if (this.loannum >= 5000 && this.loannum != 10000) {
          this.loannum -= 5000
          this.Interest = this.loannum * 1.0001
        }
      },
      translate(lang) {
        this.$i18n.locale = lang
      },
      unitConverter(e) {
        if (!e) return 0
        // 获取整数部分
        const intPart = Math.trunc(e)
        // 整数部分处理，增加,
        const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        // 预定义小数部分
        let floatPart = ''
        // 将数值截取为小数部分和整数部分
        const valueArray = e.toString().split('.')
        if (valueArray.length === 2) { // 有小数部分
          floatPart = valueArray[1].toString() // 取得小数部分
          return intPartFormat + '.' + floatPart
        }
        return intPartFormat + floatPart
      },
      goFn(type) {
        this.index = type
        if (type == 1) {
          this.$router.push('/about')
        } else if (type == 2) {
          this.$router.push('/tutorial')
        } else {
          this.$router.push('/document')
        }
      },
      getlogin() {
        if (this.flage) return
        userStepData().then(res => {
          if (localStorage.getItem('token')) {
            if (res.data.status != 0) {
              this.flage = false
              if (res.data.status == 301) {
                this.$router.push('/login')
              }
            } else {
              this.flage = false
              var step = res.data.element.step
              if (step >= 12) {
                this.$router.push('/underreview')
              } else {
                this.$router.push('/login')
              }
            }
          } else {
            this.$router.push('/login')
          }
        })
      },
      homeFn(index) {
        if (index == 0) {
          document.querySelector("#jump" + index).scrollIntoView(true);
        }
      },
      googleFn() {
        location.href =
          'https://play.google.com/store/apps/details?id=express.credit.fast.tez.loan.money.cash.pay.bank.card'
      },
      getswitch(index) {
        this.switchIndex = index
      },
      documentFn() {
        location.href = 'https://mfoeckz.com/MFOlicense.pdf'
      },
      appstoreFn() {
        location.href = 'https://apps.apple.com/kz/app/%D0%B1%D1%8B%D1%81%D1%82%D1%80%D1%8B%D0%B9-%D0%B7%D0%B0%D0%B9%D0%BC/id6751275518'
      }
    },
  };
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
    line-height: 1;
  }

  .container {
    background: #F6F8F8;
  }

  .uia{
    background: linear-gradient( 162deg, rgba(119,216,161,0.16) 0%, rgba(243,247,246,0) 100%);
    padding-bottom: 0.32rem;
  }

  .head {
    padding: 0.1rem 1.95rem 0rem 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.54rem;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headLogo_img {
    width: 1.22rem;
    height: 0.27rem;
    cursor: pointer;
  }

  .headLogo_title {
    width: 0.41rem;
    height: 0.19rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.08rem;
    color: #0aba08;
    font-style: normal;
  }

  .headMinu {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 0.77rem;
    margin-right: 0.44rem;
  }

  .headAbout {
    width: 100%;
    height: 0.23rem;
    line-height: 0.23rem;
    border-radius: 0.11rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 0.45rem;
  }

  .headAbout_text {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    font-style: normal;
    cursor: pointer;
  }

  .headAbout_textTwo {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #124A2D;
    font-style: normal;
    cursor: pointer;
  }

  .headAbout_textTwo:hover {
    color: #4C9F70;
  }

  .ioad{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.06rem;
  }

  .uyas{
    width: 0.1rem;
    height: 0.1rem;
  }

  .ijse{
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.09rem;
    color: #124A2D;
    font-style: normal;
    margin: 0 0.03rem;
  }

  .ioks{
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.09rem;
    color: #D4AF37;
    font-style: normal;
    margin: 0 0.03rem;
  }

  .iunm{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.06rem;
    color: #999999;
    font-style: normal;
  }

  .nbfd{
    position: absolute;
    right: 1.90rem;
  }
  .iola{
    padding: 0.09rem 0.1rem;
    background: #FFFFFF;
    border-radius: 0.08rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 0.1rem;
  }

  .iuas{
    width: 0.13rem;
    height: 0.13rem;
    margin-right: 0.06rem;
  }

  .ijto{
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.09rem;
    color: #124A2D;
    font-style: normal;
  }

  .headLang {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 0.29rem;
  }

  .headLang_e {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    border-radius: 0.02rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
    margin-right: 0.07rem;
  }

  .headLang_h {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
  }

  .head_btn {
    width: 0.75rem;
    height: 0.23rem;
    line-height: 0.23rem;
    text-align: center;
    background: #D4AF37;
    border-radius: 0.11rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.1rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }

  .ut {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    font-style: normal;
  }

  /* 中间部分 */
  .minu_con {
    padding: 0 1.88rem;
  }

  .minu_contwo {
    padding: 0 1.88rem;
  }

  .content {
    padding: 0 0.31rem;
    height: 2.96rem;
    background-image: url(/static/img/tbios.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto 0.63rem;
    position: relative;
  }
  .oiua{
    width: 3.04rem;
    height: 0.94rem;
    font-family: SFProText, SFProText;
    font-weight: 600;
    font-size: 0.21rem;
    color: #FFFFFF;
    line-height: 0.31rem;
    text-align: left;
    font-style: normal;
    padding-top: 0.95rem;
    z-index: inherit;
    animation: zoomInDown;
    animation-duration: 2s;
  }

  .iuqa{
      line-height: 0.25rem;
      display: inline-block;
      background-image: linear-gradient(to bottom, transparent 70%, #D4AF37 0);
      padding-bottom: 0px;
      padding-left: 0.05rem;
      padding-right: 0.05rem;
  }

  .content_mi {
    width: 2.46rem;
    background: #FFFFFF;
    box-shadow: 0rem 0.04rem 0.08rem 0rem rgba(9, 72, 9, 0.1);
    border-radius: 0.08rem;
    padding: 0.21rem 0.23rem;
    margin-bottom: 0.18rem;
  }

  .content_mi-tit {
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
    margin-bottom: 0.15rem;
    text-align: center;
  }

  .content_miNum {
    width: 1.36rem;
    display: flex;
    justify-content: space-between;
    margin: auto;
  }

  .content_miNum-img {
    width: 0.17rem;
    height: 0.17rem;
    cursor: pointer;
  }

  .content_mi-num {
    font-family: SFProText, SFProText;
    font-weight: 600;
    font-size: 0.19rem;
    color: #1A1A1A;
    font-style: normal;
  }

  .content_mi-f {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
  }

  .content_mi-line {
    width: 2.05rem;
    height: 0.05rem;
    background: #06B804;
    border-radius: 0.03rem;
    margin-bottom: 0.1rem;
  }

  .content_mi-text {
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.06rem;
    color: #666666;
    font-style: normal;
    margin-bottom: 0.14rem;
  }

  .content_mi-btn {
    width: 2.45rem;
    height: 0.42rem;
    line-height: 0.42rem;
    background: #D4AF37;
    box-shadow: 0rem 0.02rem 0rem 0rem #795D04;
    border-radius: 0.21rem;
    font-family: SFProText, SFProText;
    font-weight: bold;
    font-size: 0.13rem;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;
    margin-bottom: 0.08rem;
    cursor: pointer;
  }

  .content_mi-btn:hover {
    background: #4C9F70;
    box-shadow: 0rem 0.02rem 0rem 0rem #336c4c;
  }

  .content_mi-bom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content_mi-bom-text {
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
  }

  .content_mi-down {
    margin-left: 0.55rem;
  }

  .content_mi-down-img {
    width: 0.74rem;
    height: 0.22rem;
  }

  .contTwo {
    margin-bottom: 0.36rem;
  }

  .contTwo_title {
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.18rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.31rem;
  }

  .contF_minu {
    width: 1.56rem;
    background: #FFFFFF;
    border-radius: 0.14rem;
    padding: 0.22rem 0.21rem;
  }

  .contF_minuHead {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.09rem;
  }

  .contF_minuHead-img {
    width: 0.31rem;
    height: 0.31rem;
    margin-right: 0.06rem;
  }

  .contF_minu-title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.05rem;
  }

  .contF_minu-img {
    width: 0.46rem;
    height: 0.08rem;
  }

  .contF_minu-text {
    width: 1.56rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    text-align: left;
    font-style: normal;
    /* margin-bottom: 0.22rem; */
  }

  .contF_minu-time {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    text-align: left;
    font-style: normal;
  }

  .contTwo_min {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .contTwo_div {
    height: 1.9rem;
    background: #FFFFFF;
    border-radius: 0.09rem;
    padding: 0 0.14rem;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .contTwo_div-img {
    width: 0.36rem;
    height: 0.36rem;
    margin-bottom: 0.21rem;
  }

  .contTwo_div-title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.08rem;
  }

  .contTwo_div-text {
    width: 1.71rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    line-height: 0.1rem;
    font-style: normal;
  }

  .contThree {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .contThree_btn-y {
    width: 3.13rem;
    height: 0.42rem;
    line-height: 0.42rem;
    background: #FFFFFF;
    border-radius: 0.09rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    border-top: 0.03rem solid #4C9F70;
  }

  .contThree_btn-n {
    width: 3.13rem;
    height: 0.42rem;
    line-height: 0.42rem;
    background: #EFEFEF;
    border-radius: 0.09rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #C0C0C0;
    font-style: normal;
    cursor: pointer;
  }

  .contThree_minu {
    background: #FFFFFF;
    border-radius: 0.09rem;
    padding: 0.22rem 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .contThree_minuTwo {
    background: #FFFFFF;
    border-radius: 0.09rem;
    padding: 0.22rem 0.16rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .contThree_minu-div {
    text-align: center;
  }

  .contThree_minu-div-img {
    width: 0.16rem;
    height: 0.16rem;
    margin-bottom: 0.1rem;
  }

  .contThree_minu-div-title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.06rem;
  }

  .contThree_minu-div-text {
    width: 1.78rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    line-height: 0.1rem;
    font-style: normal;
  }

  .contThree_minu-div-textTwo {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
  }

  .contF {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }

  .contF_minuImg {
    position: absolute;
    top: 0.69rem;
    left: 0.25rem;
  }

  .contF_minuImg-left {
    width: 0.26rem;
    height: 0.26rem;
  }

  .contF_minuImgr {
    position: absolute;
    top: 0.69rem;
    right: 0.25rem;
  }

  .cont_google {
    background: #FFFFFF;
    border-radius: 0.09rem;
    padding: 0.21rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.63rem;
  }

  .cont_google-title {
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.18rem;
    color: #333333;
    font-style: normal;
    margin-right: 0.31rem;
  }

  .cont_google-img {
    width: 1.06rem;
    height: 0.31rem;
  }

  .minu_scroll::-webkit-scrollbar {
    width: 0.02rem;
    height: 1.35rem;
  }

  .minu_scroll::-webkit-scrollbar-thumb {
    background-color: #4C9F70;
    border-radius: 0.01rem;
  }

  .minu_scroll::-webkit-scrollbar-track {
    background-color: #DDE3DC;
    border-radius: 0.01rem;
  }

  .minu_scroll-title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.06rem;
  }

  .minu_scroll-text {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
    margin-bottom: 0.02rem;
  }

  /* 中间部分 end */
  .bom {
    padding: 0.44rem 1.96rem 0.24rem 1.88rem;
    background-color: #FFFFFF;
    position: relative;
  }

  .bom_bg {
    width: 2.6rem;
    height: 1.81rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .bom_title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.18rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.27rem;
  }

  .bom_min {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.2rem;
  }

  .bom_min-img {
    width: 0.23rem;
    height: 0.23rem;
    margin-right: 0.11rem;
  }

  .bom_min-text {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    cursor: pointer;
  }

  .bom_min-text-two {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
  }

  .bom_min-textpj{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
  }

  .bom_min-two {
    width: 2.17rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }

  .bom_text {
    width: 0.88rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }

  .bom_texte {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #06B804;
    margin-bottom: 0.09rem;
    font-style: normal;
  }

  .bom_text-two {
    width: 1.06rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #666666;
    line-height: 0.13rem;
    font-style: normal;
    margin-bottom: 0.1rem;
  }

  .bomIMg {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bom_img {
    width: 0.71rem;
    height: 0.21rem;
    cursor: pointer;
  }

  .payment {
    padding-right: 0.5rem;
    margin-top: 0.2rem;
  }

  .payment-line {
    width: 6.24rem;
    height: 0.01rem;
    background: #E3E3E3;
    margin-bottom: 0.2rem;
  }

  .payment_text {
    width: 5.46rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.07rem;
    color: #5C5C5C;
    line-height: 0.13rem;
    font-style: normal;
  }

  .payment_minu {
    width: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .payment_minu-img {
    width: 0.49rem;
    height: 0.31rem;
  }

  /deep/ .el-carousel__container {
    height: 1.65rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue